import React, { useEffect, useRef, useState } from 'react';
import { FiImage, FiPlay, FiUpload, FiX } from 'react-icons/fi';
import { useHubSite } from '../../shared';

// stand-in for the artwork a link brings with it (the spec shows the company's "What's next for Gold Mountain?" thumbnail)
export const ThumbArt: React.FC<{ src?: string; className?: string }> = ({ src, className }) => {
    const { short } = useHubSite();
    return <span className={`hub-thumb-art${className ? ` ${className}` : ''}`} aria-hidden="true">
        {src ? <img src={src} alt="" /> : <><em>{short}</em><FiPlay /></>}
    </span>;
};

// Main picture card (spec 409:10781 drop zone; 412:13478 adds "Picture taken from the link" above it)
// fromLink: the sub line under "Picture taken from the link", once a link's details are in
const PictureCard: React.FC<{ fromLink?: string | null }> = ({ fromLink }) => {
    const input = useRef<HTMLInputElement>(null);
    const [file, setFile] = useState<{ name: string; url: string } | null>(null);
    const [over, setOver] = useState(false);

    useEffect(() => () => { if (file) URL.revokeObjectURL(file.url); }, [file]);

    const pick = (f?: File | null) => {
        if (f && /^image\//.test(f.type)) setFile({ name: f.name, url: URL.createObjectURL(f) });
    };

    return <section className="card hub-picture">
        <div className="section-title">
            <span className="icon-tile"><FiImage /></span>
            <div className="text"><h2>Main picture</h2><div className="hint">Shown at the top of the article and in the list</div></div>
        </div>

        {file
            ? <div className="hub-picture-from">
                <ThumbArt src={file.url} />
                <span className="hub-picture-t"><strong>{file.name}</strong><span>Your picture</span></span>
                <button type="button" className="hub-icon-btn" aria-label="Remove the picture" title="Remove the picture" onClick={() => setFile(null)}><FiX /></button>
            </div>
            : fromLink && <div className="hub-picture-from">
                <ThumbArt />
                <span className="hub-picture-t"><strong>Picture taken from the link</strong><span>{fromLink}</span></span>
            </div>}

        <div className={`hub-drop${over ? ' over' : ''}`}
            onDragOver={e => { e.preventDefault(); setOver(true); }}
            onDragLeave={() => setOver(false)}
            onDrop={e => { e.preventDefault(); setOver(false); pick(e.dataTransfer.files[0]); }}>
            <span className="icon-tile"><FiImage /></span>
            <strong>{fromLink || file ? 'Or use a different picture' : 'Drag a picture here'}</strong>
            <span>JPG or PNG · at least 1200 px wide</span>
            <button type="button" className="btn-outline with-icon" onClick={() => input.current?.click()}><FiUpload /> Choose File</button>
            <input ref={input} type="file" accept="image/png,image/jpeg" hidden onChange={e => { pick(e.target.files?.[0]); e.target.value = ''; }} />
        </div>
    </section>;
};

export default PictureCard;
